import React, { lazy, Suspense } from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import NotFound404 from "../pages/NotFound404";
import Dashboard from "../pages/Users/Dashboard";
import MyTasks from "../pages/Users/MyTasks";
import GuestProtectedRoutes from "./GuestProtectedRoutes";
import AuthProtectedRoutes from "./UserAuthProtectedRoutes";

import RouteLoading from "../components/Loaders/RouteLoading";
const SignIn = lazy(() => import("../pages/Users/Auth/SignIn"));
const SignUp = lazy(() => import("../pages/Users/Auth/SignUp"));
const ForgotPassword = lazy(() => import("../pages/Users/Auth/ForgotPassword"));
const ResetPassword = lazy(() => import("../pages/Users/Auth/ResetPassword"));

// Restored Pages
const MyTask = lazy(() => import("../pages/MyTask"));
const Summarize = lazy(() => import("../pages/Summarize"));
const RolePermission = lazy(() => import("../pages/RolePermission"));
const Task = lazy(() => import("../pages/Task"));
const AdminDashboard = lazy(() => import("../pages/AdminDashboard"));
const Groups = lazy(() => import("../pages/Groups"));
const Project = lazy(() => import("../pages/Project"));
const YesNo = lazy(() => import("../pages/YesNo"));
const MyProfile = lazy(() => import("../pages/MyProfile"));
const CreateUser = lazy(() => import("../pages/CreateUser"));
const PrivacyPolicy = lazy(() => import("../pages/PrivacyPolicy"));
const TaskDetailsPage = lazy(() => import("../pages/TaskDetailsPage"));
const GoogleCallback = lazy(() => import("../components/GoogleCallback"));
const Maintenance = lazy(() => import("../pages/Maintenance"));

const UserRoute = () => {
  return (
    <Routes>
      <Route element={<GuestProtectedRoutes />}>
        <Route path="/sign-in" element={<Suspense fallback={<RouteLoading />}><SignIn /></Suspense>} />
        <Route path="/sign-up" element={<Suspense fallback={<RouteLoading />}><SignUp /></Suspense>} />
        <Route path="/forgot-password" element={<Suspense fallback={<RouteLoading />}><ForgotPassword /></Suspense>} />
        <Route path="/reset-password" element={<Suspense fallback={<RouteLoading />}><ResetPassword /></Suspense>} />
      </Route>

      <Route element={<AuthProtectedRoutes />}>
        <Route path="/" element={<Navigate to="/mytask" replace />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/mytask" element={<MyTask />} />
        <Route path="/summarize" element={<Summarize />} />
        <Route path="/roles" element={<RolePermission />} />
        <Route path="/task" element={<Task />} />
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="/groups" element={<Groups />} />
        <Route path="/project" element={<Project />} />
        <Route path="/yesno" element={<YesNo />} />
        <Route path="/myprofile" element={<MyProfile />} />
        <Route path="/task/:id" element={<TaskDetailsPage />} />

        {/* <Route path="/mytasks" element={<MyTasks />} /> */}
      </Route>

      {/* Public or Standalone Routes */}
      <Route path="/google-callback" element={<Suspense fallback={<RouteLoading />}><GoogleCallback /></Suspense>} />
      <Route path="/create-user" element={<Suspense fallback={<RouteLoading />}><CreateUser /></Suspense>} />
      <Route path="/privacy" element={<Suspense fallback={<RouteLoading />}><PrivacyPolicy /></Suspense>} />

      <Route path="/maintenance" element={<Suspense fallback={<RouteLoading />}><Maintenance /></Suspense>} />
      <Route path="*" element={<NotFound404 />} />
    </Routes>
  );
};

export default UserRoute;
